'use client';

import dynamic from 'next/dynamic';
import { isProd } from '~/constants/environment';
import { useIsAppRouter } from '~/context/common/StaticContext';
import { useIsCampaignTemplateOne } from '~/context/vdp/StaticContext';

const TrackPageExit = dynamic(
  () =>
    import(
      /* webpackChunkName: "TrackPageExit" */ '@/vdp/Analytics/TrackPageExit'
    ),
  { ssr: false }
);

const LoadStateProbe = dynamic(
  () =>
    import(
      /* webpackChunkName: "LoadStateProbe" */ '@/vdp/automation/LoadStateProbe'
    ),
  { ssr: false }
);

const VehicleDetailsStandardContainer = dynamic(
  () =>
    import(
      /* webpackChunkName: "VehicleDetailsStandardContainer" */ '@/vdp/VehicleDetailsContainer/VehicleDetailsStandardContainer'
    )
);

const VehicleDetailsLiteContainer = dynamic(
  () =>
    import(
      /* webpackChunkName: "VehicleDetailsLiteContainer" */ '@/vdp/VehicleDetailsContainer/VehicleDetailsLiteContainer'
    )
);

export default function VehicleDetailsContainer() {
  const isCampaignTemplateOne = useIsCampaignTemplateOne();
  const isAppRouter = useIsAppRouter();

  return (
    <>
      {isAppRouter && <TrackPageExit />}
      {!isProd && <LoadStateProbe />}
      {isCampaignTemplateOne ? (
        <VehicleDetailsLiteContainer />
      ) : (
        <VehicleDetailsStandardContainer />
      )}
    </>
  );
}
